import React from 'react'
import { ColumnRank, ColumnBib, ColumnName, ColumnNoc, ColumnResult, ColumnRecords, ColumnQualification, ColumnRankNoResult } from "components/common/TableColumns"
import { ColumnHeatRowSpan, ColumnLaneAColspan, ColumnLaneBColspan, ColumnResultLane, ColumnResultRR, ColumnHeat, ColumnLane, ColumnLuckyLoserColSpan, ColumnResultRowSpan } from "./TableColumns"
import { ColumnPty } from '../common/TableColumns'



export function speedSeedingHeatsColumns() {
    return (
        [
            ColumnHeatRowSpan({}),
            ColumnLaneAColspan({}),
            ColumnLaneBColspan({})
        ]
    )
}

export function speedSeedingResultColumns() {
    return (
        [
            ColumnRank({}),
            ColumnBib({}),
            ColumnNoc({}),
            ColumnName({}),
            ColumnResultLane({ lane: 'A', label: 'HeaderLaneA' }),
            ColumnResultLane({ lane: 'B', label: 'HeaderLaneB' }),
            ColumnResult({ label: 'HeaderBestTimeN', className: 'text-center', headerClassName: 'text-center w-10' }),
            ColumnRecords({})
        ]
    )
}

export function speedQualificationHeatsColumns() {
    return (
        [
            ColumnHeat({ qual: true, accessor: 'heatSortOrder', enableRowSpan: true, rowSpanType: 'cell', className: 'text-center', headerClassName: 'text-center w-10',
        }),
            ColumnLane({ label: 'HeaderLaneStatic' }),
            ColumnBib({ disableSort: true }),
            ColumnNoc({ disableSort: true }),
            ColumnName({ disableSort: true }),
            ColumnPty({}),
            ColumnResultRR({ label: 'HeaderTime' }),
            ColumnQualification({})
        ]
    )
}

export function luckyLoserColumns() {
    return (
        [
            ColumnLuckyLoserColSpan({}),
            ColumnResultRowSpan({})
        ]
    )
}

export function summaryColumns() {
    return (
        [
            ColumnRank({ disableSort: true }),
            ColumnBib({ disableSort: true, label: 'HeaderBibNoR' }),
            ColumnNoc({ disableSort: true }),
            ColumnName({ disableSort: true }),
            ColumnPty({}),
            ColumnResult({ label: 'HeaderFastestTime', headerClassName: 'text-end w-20' }),
            ColumnRecords({}),
            ColumnQualification({})
        ]
    )
}

export function standingsColumns() {
    return (
        [
            ColumnRankNoResult({ disableSort: true, isEventRanking: true }),
            ColumnBib({ disableSort: true, label: 'HeaderBibNoR' }),
            ColumnNoc({ disableSort: true }),
            ColumnName({ disableSort: true })
        ]
    )
}
